import Spinner from 'react-bootstrap/Spinner';

function LoaderSpinner() {
  return <Spinner animation="border" className="recepientLoader" />;
}

export default LoaderSpinner;